/** A place to put miscellaneous config options */
export default {
  shouldUseRemoteContent: true,
  contentful: {
    space: 'vuoh8ba7k2m7',
    accessToken: 'f2YjjbrzFAsRUmTD_evXRusqDCp4RjyaJlv28lzOI5E',
  },
  isPaged: false,
  isHeaderUnderFirstBlock: false,
  /** 'dot' or 'full' */
  nav: 'dot',
  twitterHandle: 'StarrConspiracy',
};
